import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { toast } from 'react-toastify';
import {
  createLeadRequest,
  createLeadSuccess,
  createLeadFailure,
  getAllLeadsRequest,
  getAllLeadsSuccess,
  getAllLeadsFailure,
  updateLeadRequest,
  updateLeadSuccess,
  updateLeadFailure,
  getLeadByJewellerRequest,     
  getLeadByJewellerSuccess,    
  getLeadByJewellerFailure, 
} from './requiredSlice';

// --- API Calls ---
function sanitizeLeadAssignTo(leadData) {
  const cleaned = { ...leadData };
  if (cleaned.assignTo === undefined) return cleaned;
  cleaned.assignTo = (
    Array.isArray(cleaned.assignTo) ? cleaned.assignTo : [cleaned.assignTo]
  )
    .map((item) => (typeof item === 'string' ? item : item?._id))
    .filter(Boolean);
  return cleaned;
}

function createLeadApi(leadData) {
  return axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/api/v1/lead/create-lead`,
    sanitizeLeadAssignTo(leadData),
  );
}

function getAllLeadsAPI(payload) {
  return axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/api/v1/lead/get-all-leads`,
    { params: payload },
  );
}

function updateLeadApi(leadData) {
  return axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/api/v1/lead/update-lead`,
    sanitizeLeadAssignTo(leadData),
  );
}

function getLeadByJewellerApi(jewellerId) {
  return axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/api/v1/lead/by-jeweller/${jewellerId}`,
  );
}

// --- Sagas ---
function* createLeadSaga(action) {
  try {
    const response = yield call(createLeadApi, action.payload);
    const { success, message } = response.data;

    if (success) {
      yield put(createLeadSuccess(response.data));
      toast.success(message || 'Lead created successfully.');
      yield put(getAllLeadsRequest({ page: 0, limit: 10, search: '' }));
    } else {
      yield put(createLeadFailure(response.data));
      toast.error(message || 'Failed to create lead.');
    }
  } catch (error) {
    const errData = error.response?.data || { message: 'API Error' };
    yield put(createLeadFailure(errData));
    toast.error(errData.message || 'Something went wrong.');
  }
}

function* fetchAllLeads(action) {
  try {
    const response = yield call(getAllLeadsAPI, action.payload);
    yield put(getAllLeadsSuccess(response.data));
  } catch (error) {
    yield put(
      getAllLeadsFailure(error.response?.data || { message: 'API Error' }),
    );
  }
}

function* handleUpdateLead(action) {
  try {
    const response = yield call(updateLeadApi, action.payload);
    yield put(updateLeadSuccess(response.data));
    yield put(getAllLeadsRequest({ page: 0, limit: 10, search: '' }));
  } catch (error) {
    yield put(
      updateLeadFailure(error.response?.data || { message: 'API Error' }),
    );
  }
}

function* fetchLeadByJeweller(action) {
  try {
    const response = yield call(getLeadByJewellerApi, action.payload);
    yield put(getLeadByJewellerSuccess(response.data));
  } catch (error) {
    yield put(
      getLeadByJewellerFailure(error.response?.data || { message: 'API Error' }),
    );
  }
}

// --- Root Saga ---
export default function* requiredSaga() {
  yield takeLatest(createLeadRequest.type, createLeadSaga);
  yield takeLatest(getAllLeadsRequest.type, fetchAllLeads);
  yield takeLatest(updateLeadRequest.type, handleUpdateLead);
  yield takeLatest(getLeadByJewellerRequest.type, fetchLeadByJeweller);
}
